import { ApToggleSwitch, colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const TooltipContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 8px 12px;
	margin: 0;
	z-index: 2;
	background-color: ${colors.white};
	#tooltip_content {
		display: flex;
		flex-direction: column;
	}
`;

export const TooltipItemTitle = styled.strong`
	font-size: 13px;
	font-weight: bold;
`;

export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	column-gap: 1%;
	#price_filter,
	#commodity_l2_filter,
	#commodity_l3_filter {
		border: 1px solid #cccccc;
	}
	#scale_marker_by_volume {
		display: flex;
		align-items: center;
	}
`;

export const StatsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 35px;
`;

export const KPISection = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	gap: 10px;
`;

export const KpiCard = styled.div`
	width: 100%;
	padding: 1em;
	margin: 0.5% 0;
	background-color: ${colors.white};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
`;

export const CardValue = styled.div`
	font-size: 1.3rem;
	font-weight: bolder;
`;

export const CardText = styled.div`
	font-size: 0.8rem;
	padding-left: 0.2em;
`;

export const ToggleSwitch = styled(ApToggleSwitch)`
	margin: 2px 0 0 3px;
`;

export const TableWrapper = styled.div`
	.ag-theme-balham {
		.ag-header-cell {
			text-align: center;
		}
		.ag-header-row {
			.ag-header-cell {
				.ag-cell-label-container {
					justify-content: center;

					.ag-header-cell-label {
						flex: unset;
					}
				}
			}
		}
		.ag-row {
			.ag-cell {
				text-align: center;
			}
		}
	}
`;
